import { useState, useEffect } from "react";
import { HttpsCallableResult, httpsCallable } from "@firebase/functions";
import { functions } from "../../../firebaseConfig";

type RsicWhitelistCheckResult = {
  isOnRsicWhitelist: boolean;
};

type UseIsOnRsicWhitelistProps = {
  btcAddress?: string;
  ordAddress?: string;
};

export const useIsOnRsicWhitelist = ({
  btcAddress,
  ordAddress,
}: UseIsOnRsicWhitelistProps) => {
  const [isLoadingIsOnRsicWhitelist, setIsLoadingIsOnRsicWhitelist] =
    useState(true);
  const [isOnRsicWhitelist, setIsOnRsicWhitelist] = useState<boolean | null>(
    false,
  );
  const [isRsicError, setIsRsicError] = useState<Error | null>(null);

  useEffect(() => {
    const checkRsicWhitelist = httpsCallable(functions, "checkRsicWhitelist");

    checkRsicWhitelist({ btcAddress, ordAddress })
      .then((result: HttpsCallableResult) => {
        const data = result.data as RsicWhitelistCheckResult;
        setIsOnRsicWhitelist(data.isOnRsicWhitelist);
        setIsLoadingIsOnRsicWhitelist(false);
      })
      .catch((err: Error) => {
        setIsRsicError(err);
        setIsLoadingIsOnRsicWhitelist(false);
      });
  }, [btcAddress, ordAddress]);

  return { isLoadingIsOnRsicWhitelist, isOnRsicWhitelist, isRsicError };
};

export default useIsOnRsicWhitelist;
